export default __webpack_public_path__ + "static/media/testocr.3b7df312.jpg";